import Popup from '../../../../../components/Popup/Popup'
import { Button, BUTTON_TYPES } from '../../../../../components/Button'
import { BTN_TXT } from '../../../../../constants'
import {
  Typography,
  TYPOGRAPHY_WEIGHT
} from '../../../../../components/Typography'
import { useDispatch } from 'react-redux'
import { setLoading } from '../../../../../redux/store/common/slice'
import { addToMyVendors } from '../api'
import { notification } from '../../../../../components/Notification'
import { useVendorsPagePopup } from '../../Providers/VendorsPagePopupProvider'

export const AddToMyVendorsModal = ({ callback }) => {
  const dispatch = useDispatch()

  const {
    addToMyVendorsPopup: { state, actions }
  } = useVendorsPagePopup()

  const { vendor } = state.payload

  const onCancel = () => actions.close()

  const onUpgrade = async () => {
    if (!vendor?.uuid) return
    try {
      dispatch(setLoading(true))
      await addToMyVendors({ vendors: [vendor.uuid] })
      notification.success({
        message: `Vendor has been successfully added.`
      })
      onCancel()
      callback()
    } catch (e) {
      console.error(e)
    } finally {
      dispatch(setLoading(false))
    }
  }

  if (!vendor) return null
  return (
    <Popup
      {...state}
      onCancel={onCancel}
      title={`Add ${vendor.business_name} to My vendors`}
      width={442}
      footer={
        <>
          <Button onClick={onCancel} type={BUTTON_TYPES.DEFAULT} upperCase>
            {BTN_TXT.CANCEL}
          </Button>
          <Button type={BUTTON_TYPES.PRIMARY} upperCase onClick={onUpgrade}>
            {BTN_TXT.ADD}
          </Button>
        </>
      }
    >
      <Typography.Headline6 weight={TYPOGRAPHY_WEIGHT.NORMAL}>
        Once added, you will be able to engage with this vendor.
      </Typography.Headline6>
    </Popup>
  )
}
